import type { CanActivateFn, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';

/**
 * Redirects the user to the login page if they are not authenticated.
 */
export const authenticatedGuard: CanActivateFn = (): Observable<true | UrlTree> => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);

    return authService.isAuthenticated$.pipe(
        map(authenticated => {

            if (authenticated) {
                return true;
            }

            // Otherwise redirect them to the login page
            return router.createUrlTree(['/auth/login']);
        })
    );
};
